import React from 'react';

type Props = {
	width: number;
	height: number;
	className?: string;
};

export const PhoneIcon = ({ width = 24, height = 24, className }: Props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={width}
		height={height}
		className={className}
		viewBox="0 0 256 256"
		fill="none"
		id="my-svg"
	>
		<defs>
			<linearGradient id="gradient1">
				<stop className="stop1" offset="0%" stopColor="none" />
				<stop className="stop2" offset="100%" stopColor="none" />
			</linearGradient>
		</defs>
		<rect id="backgr" width={256} height={256} fill="none" rx={60} />
		<path
			d="M206.773 200.523c5.291 -5.291 8.853 -11.883 10.795 -19.371l-33.419 -33.429 -33.952 18.869a168.96 168.96 0 0 1 -33.931 -26.411 168.971 168.971 0 0 1 -26.411 -33.931l18.859 -33.952L75.307 38.88c-7.499 1.941 -14.08 5.504 -19.371 10.795C30.923 74.667 44.437 128.693 86.08 170.347c41.653 41.653 95.68 55.157 120.683 30.165Z"
			stroke="currentColor"
			strokeWidth={14}
			strokeLinecap="round"
			strokeLinejoin="round"
			id="my-path"
			transform="translate(0,0) scale(1)"
		/>
	</svg>
);
